export function scrollTop() {
  window.scrollTo({ top: 0, behavior: "auto" });
}
